//#region imports
import React, { useEffect, useState } from 'react';

// custom components
import { Card, CustomSpinner } from '_atoms';

// bootstrap
import Row from 'react-bootstrap/Row';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectForecast, selectWeatherStatus, getWeather } from '_redux/slices/analytics/weather';
import { selectDateToISO } from '_redux/slices/prm-bookings/calendar';
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";

// exterior libraries
import { Block, Flex, Text, ListItem, List } from '@tremor/react';
//#endregion


const WeatherTile = (props) => {

    //#region redux
    const dispatch = useDispatch();
    const dbUser = useSelector(selectFirebaseInfo);
    const weather = useSelector(selectForecast)                     // weather forecast
    const date = useSelector(selectDateToISO);                      // date of calendar
    const weatherStatus = useSelector(selectWeatherStatus)          // get weather status 

    //#endregion

    // states
    const [loading, setLoading] = useState(true)

    //#region use effects
    useEffect(() => {
        // on render get weather
        dispatch(getWeather(dbUser && dbUser.details && dbUser.details.authority ? dbUser.details.authority : ""));
    }, [])

    // update loader state on weather status selector
    useEffect(() => {
        if (weatherStatus == 'loading') {
            setLoading(true)
        }
        else {
            setLoading(false)
        }
    }, [weatherStatus])

    //#endregion
    //component to render weather item 
    const WeatherListItem = (props) => {
        return (
            <ListItem>
                <Flex>
                    <Text truncate={true}>{props.title}</Text>
                    <Text>{loading ? <CustomSpinner size={"small"} /> : <>{props.data}</>}</Text>
                </Flex>
            </ListItem>
        )
    }

    return (
        <Card>
            <Row>
                <Flex marginTop="mt-1" alignItems="items-start">
                    <Block>
                        <List>

                            {/* highest temperature */}
                            <WeatherListItem title={"Highest Temperature"} data={weather && weather[date] && weather[date].highTemperatureValue ? weather[date].highTemperatureValue + "°C" : ""} />
                            {/* visibility */}
                            <WeatherListItem title={"Visibility"} data={weather && weather[date] && weather[date].lowTemperatureValue ? weather[date].lowTemperatureValue + "°C" : ""} />
                            {/* Rain Probability */}
                            <WeatherListItem title={"Rain Probability "} data={weather && weather[date] && weather[date].probabilityOfPrecip ? weather[date].probabilityOfPrecip + "%" : ""} />


                        </List>
                    </Block>
                </Flex>
            </Row>
        </Card>
    );
};

export default WeatherTile;